import { render, staticRenderFns } from "./validaCarteiraFuncionalDigital.vue?vue&type=template&id=07913976&scoped=true&"
import script from "./validaCarteiraFuncionalDigital.vue?vue&type=script&lang=js&"
export * from "./validaCarteiraFuncionalDigital.vue?vue&type=script&lang=js&"
import style0 from "./validaCarteiraFuncionalDigital.vue?vue&type=style&index=0&id=07913976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07913976",
  null
  
)

export default component.exports